module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-10.bb803ab8.jpeg";